'use client';

import { createContext, ReactNode, useContext } from 'react';

export interface PageContextProps {
  children?: ReactNode;
  isArticle?: boolean;
  isCampaign?: boolean;
}

const PageContext = createContext<PageContextProps | undefined>(undefined);

export const PageContextProvider = ({ children, isArticle, isCampaign }: PageContextProps) => {
  return <PageContext.Provider value={{ isArticle, isCampaign }}>{children}</PageContext.Provider>;
};

export const usePageContext = () => {
  const context = useContext(PageContext);

  return context;
};
